import { gql } from "@apollo/client"

export const GET_SUGGESTED_TERMINALS = gql`
  query getSuggestedTerminals($group: ID!, $first: Int, $skip: Int, $search: String) {
    suggestedTerminals(group: $group, first: $first, skip: $skip, search: $search) {
      id
      serialNumber
      nickname
      imageUrl
    }
  }
`
